import React, {PureComponent} from 'react';
import LazyLoad from './react-lazyload/index';


function placeholderImage(altText) {
    return (
        <div
            className="image__placeholder"
            alt={altText}
        />
    );
}

class LazyImage extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }

    handleError = () => {
        this.setState({hasError: true});
    }

    render() {
        const placeholder = placeholderImage(this.props.altText);
        const imageState = this.state.hasError
            ? 'lazy-image--error'
            : 'lazy-image';

        return (
            <LazyLoad once offset={100} placeholder={placeholder} >
                <img
                    className={`${this.props.className} ${imageState}`}
                    src={this.props.source}
                    alt={this.props.altText}
                    onError={this.handleError}
                />
            </LazyLoad>
        );
    }
}


export default LazyImage;
